import React, { useEffect, useState } from "react";
import { Card, Table, Button, Modal, Form } from "react-bootstrap";
import { useCompany } from "../contextjs/CompanyContext";

const CompanyInfo = () => {
    const { companyInfo, fetchCompanyInfo, updateCompanyInfo } = useCompany();
    const [showEditModal, setShowEditModal] = useState(false);
    const [formData, setFormData] = useState({
        company_name: "",
        company_address: "",
        company_email: "",
        company_phone_number: "",
        company_registration_number: "",
        company_vat_number: "",
        company_kra_pin: "",
        shareholders: [], // Added for shareholders
    });

    useEffect(() => {
        fetchCompanyInfo();
    }, [fetchCompanyInfo]);

    useEffect(() => {
        if (companyInfo) {
            setFormData({
                ...companyInfo,
                shareholders: companyInfo.shareholders || [], // Ensure shareholders are included
            });
        }
    }, [companyInfo]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleShareholderChange = (index, field, value) => {
        const updatedShareholders = [...formData.shareholders];
        updatedShareholders[index][field] = value;
        setFormData((prev) => ({ ...prev, shareholders: updatedShareholders }));
    };

    const handleAddShareholder = () => {
        setFormData((prev) => {
            return ({
                ...prev,
                shareholders: [
                    ...prev.shareholders,
                    {id: null, name: "", id_number: "", phone_number: "", email: "", shares_percentage: ""},
                ],
            });
        });
    };

    const handleRemoveShareholder = (index) => {
        const updatedShareholders = [...formData.shareholders];
        updatedShareholders.splice(index, 1);
        setFormData((prev) => {
            return ({...prev, shareholders: updatedShareholders});
        });
    };

    // const handleSave = async () => {
    //     // ensure shareholders are sent as part of the payload
    //     const payload = { ...formData };
    //
    //     // remove any placeholder shareholders with incomplete details
    //     payload.shareholders = payload.shareholders.filter((shareholder) => shareholder.name);
    //
    //     await updateCompanyInfo(formData);
    //     setShowEditModal(false);
    // };

    const handleSave = async () => {
        const cleanedShareholders = formData.shareholders.map((shareholder) => ({
            id: shareholder.id || null,
            name: shareholder.name,
            id_number: shareholder.id_number,
            phone_number: shareholder.phone_number,
            email: shareholder.email,
            shares_percentage: shareholder.shares_percentage,
        }));

        const payload = {
            ...formData,
            shareholders: cleanedShareholders,
        };

        // console.log("Payload being sent to API:", payload); // Debugging
        await updateCompanyInfo(payload);
        setShowEditModal(false);
    };


    if (!companyInfo) {
        return <p>Loading company information...</p>;
    }

    return (
        <div className="container mt-5">
            <Card>
                <Card.Header>
                    <h1>{companyInfo.company_name}</h1>
                </Card.Header>
                <Card.Body>
                    <p><strong>P.O Box:</strong> {companyInfo.company_address}</p>
                    <p><strong>Email:</strong> {companyInfo.company_email}</p>
                    <p><strong>Phone no.:</strong> {companyInfo.company_phone_number}</p>
                    <p><strong>Registration No.:</strong> {companyInfo.company_registration_number}</p>
                    <p><strong>VAT No.:</strong> {companyInfo.company_vat_number}</p>
                    <p><strong>KRA Pin:</strong> {companyInfo.company_kra_pin}</p>

                    <h3>Shareholders</h3>
                    {formData.shareholders && formData.shareholders.length > 0 ? (
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>ID Number</th>
                                    <th>Phone Number</th>
                                    <th>Email</th>
                                    <th>Shares (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formData.shareholders.map((shareholder, index) => (
                                    <tr key={index}>
                                        <td>{shareholder.name}</td>
                                        <td>{shareholder.id_number}</td>
                                        <td>{shareholder.phone_number}</td>
                                        <td>{shareholder.email}</td>
                                        <td>{shareholder.shares_percentage}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>No shareholders found.</p>
                    )}

                    <Button variant="primary" onClick={() => setShowEditModal(true)}>
                        Edit Company Info
                    </Button>
                </Card.Body>
            </Card>

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Company Info</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Company Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_name"
                                value={formData.company_name || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>P.O Box</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_address"
                                value={formData.company_address || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name="company_email"
                                value={formData.company_email || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_phone_number"
                                value={formData.company_phone_number || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Registration No.</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_registration_number"
                                value={formData.company_registration_number || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>VAT No.</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_vat_number"
                                value={formData.company_vat_number || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>KRA Pin</Form.Label>
                            <Form.Control
                                type="text"
                                name="company_kra_pin"
                                value={formData.company_kra_pin || ""}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <h5>Shareholders</h5>
                        {formData.shareholders.map((shareholder, index) => (
                            <div key={index} className="mb-3">
                                <Form.Group className="mb-2">
                                    <Form.Label>Shareholder Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={shareholder.name || ""}
                                        onChange={(e) => handleShareholderChange(index, "name", e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>ID Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={shareholder.id_number || ""}
                                        onChange={(e) => handleShareholderChange(index, "id_number", e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Phone Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={shareholder.phone_number || ""}
                                        onChange={(e) => handleShareholderChange(index, "phone_number", e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={shareholder.email || ""}
                                        onChange={(e) => handleShareholderChange(index, "email", e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Shares (%)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={shareholder.shares_percentage || ""}
                                        onChange={(e) => handleShareholderChange(index, "shares_percentage", e.target.value)}
                                    />
                                </Form.Group>
                                <Button variant="danger" onClick={() => handleRemoveShareholder(index)}>
                                    Remove Shareholder
                                </Button>
                            </div>
                        ))}
                        <Button variant="secondary" onClick={handleAddShareholder} className="mt-3">
                            Add Shareholder
                        </Button>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSave}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CompanyInfo;
